import "./FeaturesTabStyles.scss";
import $ from "jquery";
import keycode from "keycode";
import { applyHoverZoomEffectWrapper } from "../FunctionsCore";
const featuresTab = (featuresTabParameter) => {
    $(() => {
        const $roleTab = $('[role="tab"]');
        const $tabIcon = $(".tab_icon");
        $tabIcon
            .on("keydown", function () {
            const $this = $(this);
            $tabIcon.removeClass("active");
            $this.addClass("active");
            $tabIcon.attr("aria-selected", "false");
            $this.attr("aria-selected", "true");
        })
            .on("mouseover", function () {
            const $this = $(this);
            $tabIcon.removeClass("active");
            $tabIcon.attr("aria-selected", "false");
            $this.attr("aria-selected", "true");
            $this.addClass("active");
            const tab = $this.attr("data-click");
            $(".tab").removeClass("active");
            $(`#${tab}`).addClass("active");
        });
        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;
        $('[role="tablist"]').on("keydown", (ke) => {
            const which = ke.which;
            if (which === keycode.codes.left || which === keycode.codes.right) {
                $roleTab.eq(tabFocus).attr("tabindex", "-1");
                if (which === keycode.codes.right) {
                    // Move right
                    tabFocus += 1;
                    // If we're at the end, go to the start
                    if (tabFocus >= $roleTab.length) {
                        tabFocus = 0;
                    }
                }
                else if (which === keycode.codes.left) {
                    // Move left
                    tabFocus -= 1;
                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = $roleTab.length - 1;
                    }
                }
                $roleTab.eq(tabFocus).attr("tabindex", "0").focus();
            }
        });
        applyHoverZoomEffectWrapper(featuresTabParameter.applyHoverZoomEffectWrapperParameter);
    });
};
export { featuresTab };
